export default __webpack_public_path__ + "static/media/banner1.ee4102d6.jpg";